import btnStyles from '../ConvertButton/ConvertButton.module.css';

export interface DownloadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  zipMode?: boolean;
  label?: string;
}

export function DownloadButton({
  onClick,
  disabled = false,
  zipMode = false,
  label,
}: DownloadButtonProps) {
  const buttonLabel = label ?? (zipMode ? 'Download ZIP' : 'Download .xmp');

  return (
    <button className={`${btnStyles.btn} ${btnStyles.secondary}`} onClick={onClick} disabled={disabled}>
      {zipMode ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      )}
      {buttonLabel}
    </button>
  );
}

/** Trigger a file download in the browser */
export function triggerDownload(content: string, filename: string, mimeType = 'application/xml'): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** Trigger a blob download */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default DownloadButton;
